import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';

export function useAuth() {
  const authStore = useAuthStore();

  // Expose the user from the store
  const user = computed(() => authStore.user);

  // Expose isAuthenticated from the store
  const isAuthenticated = computed(() => authStore.isAuthenticated);

  // Return the values and functions needed by components
  return {
    user,
    isAuthenticated,
    login: authStore.login,
    logout: authStore.logout,
    register: authStore.register,
    loginWithGoogle: authStore.loginWithGoogle,
    setToken: authStore.setToken,
    fetchUser: authStore.fetchUser,
    uploadAvatar: authStore.uploadAvatar,
    deleteAvatar: authStore.deleteAvatar,
    avatarUrl: computed(() => authStore.avatarUrl),
    avatarUploading: computed(() => authStore.avatarUploading)
  };
}